import {Helmet} from '@dr.pogodin/react-helmet';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {SettingsTemplate, SettingsTemplateHeader} from '@dms/settings/shared';
import {DmsDataGrid} from '@dms/shared';

export function WarehousesSupplierAccounts() {
  const header: SettingsTemplateHeader = {
    title: i18n.t('entity.warehouse.labels.supplierAccounts'),
  };

  return (
    <>
      <Helmet title={i18n.t('entity.warehouse.labels.supplierAccounts')} />
      <SettingsTemplate
        data-testid={testIds.settings.warehousesSupplierAccounts('template')}
        header={header}
      >
        <DmsDataGrid
          gridCode="warehouse-supplier-account"
          emptyState={{
            headline: i18n.t('general.labels.noData'),
          }}
          data-testid={testIds.settings.warehousesSupplierAccounts('warehouse-supplier-account')}
        />
      </SettingsTemplate>
    </>
  );
}
